import { Component, OnInit } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';

import { UpdateClientFileTemplateComponent } from '../update-client-file-template/update-client-file-template.component';
import { ModalUpdateClientFilePathComponent } from '../modal-update-client-file-path.component';
import { UtilsService } from '../../../../../core/services/http-services/utils.service';
import { ManageSystemService } from '../../../../../core/services/http-services/manage-system.service';
import { ManageSystemMessagesEnum } from '../../../../../core/enums/toastr-messages/manage-system-messages.enum';
import { AppConstants } from '../../../../../app.constants';

@Component({
  selector: 'update-windows-client',
  standalone: true,
  imports: [
    UpdateClientFileTemplateComponent
  ],
  templateUrl: './update-windows-client.component.html'
})
export class UpdateWindowsClientComponent implements OnInit {
  public downloadPercentageProgress: number = 0;
  public filePath: string;
  public localFile: File = null;
  public isPendingFileDownload: boolean = false;

  constructor(
    private readonly dialogRef: MatDialogRef<ModalUpdateClientFilePathComponent>,
    private readonly toastrService: ToastrService,
    private manageSystemService: ManageSystemService,
    private readonly utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    this.utilsService.getAgentUpdateFileName().pipe(take(1)).subscribe(fileName => {
      this.filePath = '';
    });
  }

  public save(): void {
    this.utilsService.setAgentUpdateFileName(this.filePath).pipe(take(1)).subscribe(() => {
      this.toastrService.success(`${ManageSystemMessagesEnum.NewFilePathIs} '${this.filePath}'`,
        ManageSystemMessagesEnum.UpdateClientFileSuccess);
      this.dialogRef.close();
    });
  }

  public setFileData(file: File): void {
    if (file && file.name && file.name.endsWith(AppConstants.EXE_FILE_TYPE)) {
      this.localFile = file;
    } else {
      this.toastrService.error(ManageSystemMessagesEnum.WrongFileTypeUploadingDescription,
        ManageSystemMessagesEnum.WrongFileTypeUploadingTitle);
    }
  }

  public uploadFile(): void {
    this.manageSystemService.importUpdateClientFile(this.localFile).subscribe((enentUploadingData: any) => {
      this.calculatedownloadPercentageProgress(enentUploadingData);
    }, () => {
      this.dialogRef.close();
    });
  }

  public setDefaultPath(): void {
    if (this.filePath !== AppConstants.UPDATE_CLIENT_FILE_PATH) {
      this.filePath = AppConstants.UPDATE_CLIENT_FILE_PATH;
      this.utilsService.setAgentUpdateFileName(this.filePath).pipe(take(1)).subscribe(() => {
        this.toastrService.success(ManageSystemMessagesEnum.ClientUploadPathNullify);
      });
    } else {
      this.toastrService.info(ManageSystemMessagesEnum.ClientUploadPathIsAlreadyDefault);
    }
  }

  private calculatedownloadPercentageProgress(eventData: any): void {
    if (eventData.type === HttpEventType.UploadProgress || eventData.type === HttpEventType.DownloadProgress) {
      this.downloadPercentageProgress = Math.round(100 * eventData.loaded / eventData.total);
      this.isPendingFileDownload = true;
    } else if (eventData.type === HttpEventType.Response) {
      this.utilsService.setAgentUpdateFileName(this.localFile.name).pipe(take(1)).subscribe(() => {
        this.dialogRef.close();
        this.toastrService.success(`${ManageSystemMessagesEnum.NewFilePathIs} '${this.localFile.name}'`,
          ManageSystemMessagesEnum.UpdateClientFileSuccess);
      });
    }
  }
}
